import { render, staticRenderFns } from "./EditPaper.vue?vue&type=template&id=127c83d2&scoped=true"
import script from "./EditPaper.vue?vue&type=script&lang=js"
export * from "./EditPaper.vue?vue&type=script&lang=js"
import style0 from "./EditPaper.vue?vue&type=style&index=0&id=127c83d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127c83d2",
  null
  
)

export default component.exports